<template>
<div class="card card-dashboard-sixteen" style='height:100%' v-loading='loading'>
    <div class="card-header" style="background-color: transparent;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 20px 0;">
        <h6 class="card-title">Members</h6>
        <small class='mg-b-10'>
            <router-link :to='{path:$route.params.fund_code+"/memberbasic/",query:{name:$route.query.name,page:"Mamber Basic Details"}}'>
                Member Basic Details
            </router-link>
        </small>
    </div><!-- card-header -->
    <div class="card-body">
        <div class="table-responsive">
        <table class="table mg-b-0">
            <tbody>
                <tr v-for='(member,index) in members' :key='member.id'>
                    <td>
                        <div class="az-img-user"><img src='../../../assets/img/new/user.png' alt=""></div>
                    </td>
                    <td>
                        <h6 class="mg-b-0 tx-inverse">{{isSample?'Mr Mike Sample '+(index+1):member.trustee_name}}</h6>
                        <small class="tx-11 tx-gray-500">{{member.member_account_type}}</small>
                    </td>
                </tr>
            </tbody>
        </table>
        </div><!-- table-responsive -->
    </div><!-- card-body -->
</div><!-- card -->
</template>
<script>
export default {
  name: 'fundmember',
  components: {
    
  },
  data(){
      return{
         isSample:false,
         members:[],
         loading:true
      }
  },
  created(){
        this.getMembers();
    },
  methods:{
        getMembers: function(){
            const userdetail = JSON.parse(localStorage.getItem('userdetail'));
            this.isSample = userdetail['sample'];
            this.$api.funddashboard_api.fundMember(this.$route.params.fund_code).then(response =>{
                //note that the data for prev year and this year is reversed
                this.members=response.data['members']
                this.loading=false
            });
        
        },
    }
}
</script>